module.exports = __webpack_public_path__ + "img/united1-cover-3.8c266032.jpg";